import { createAction } from '@reduxjs/toolkit'

export const fetchBonuses = createAction('bonus/fetchBonuses')
export const updateBonus = createAction('bonus/updateBonus')
export const createBonus = createAction('bonus/createBonus')
export const deleteBonus = createAction('bonus/deleteBonus')
